import { CSSProperties, ReactNode } from 'react';

interface Props {
  children: ReactNode,
  style?: CSSProperties,
}

const Item = (props: Props) => {
  const {
    children, style,
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '48px',
        gap: '10px',
        padding: '0px 8px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
        ...style,
      }}>
      {children}
    </div>
  );
};

export default Item;
